import { useState } from 'react';
import { api } from '../lib/api';
import type { ModeAResponse, ModeBResponse, ModeCResponse } from '../lib/types';

export function useAI() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const recommendWorkstyle = async (employeeId: string, forceRefresh = false): Promise<ModeAResponse | null> => {
    setLoading(true);
    setError(null);
    try {
      const result = await api.ai.recommendWorkstyle(employeeId, forceRefresh);
      return result.recommendation as unknown as ModeAResponse;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'AI分析に失敗しました');
      return null;
    } finally {
      setLoading(false);
    }
  };

  const analyzeTeam = async (teamId: string, forceRefresh = false): Promise<ModeBResponse | null> => {
    setLoading(true);
    setError(null);
    try {
      const result = await api.ai.analyzeTeam(teamId, forceRefresh);
      return result.recommendation as unknown as ModeBResponse;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'チーム分析に失敗しました');
      return null;
    } finally {
      setLoading(false);
    }
  };

  const analyzeCompatibility = async (
    employeeAId: string,
    employeeBId: string,
    relationship: string,
  ): Promise<ModeCResponse | null> => {
    setLoading(true);
    setError(null);
    try {
      const result = await api.ai.analyzeCompatibility({
        employee_a_id: employeeAId,
        employee_b_id: employeeBId,
        relationship,
      });
      return result.recommendation as unknown as ModeCResponse;
    } catch (err) {
      setError(err instanceof Error ? err.message : '相性分析に失敗しました');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    recommendWorkstyle,
    analyzeTeam,
    analyzeCompatibility,
  };
}
